"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeCounter = makeCounter;

function makeCounter() {
  var count = 0;
  return function counter() {
    count += 1;
    return count;
  };
}